<template>
  <PrintPageLandscape :page-number="pageNumber" :page-count="pageCount">
    <PresentationCover>
      <template #corner><i>e way</i></template>

      <h1 class="presentation-cover__title">
        IAB-basierte<br />
        Investitionen in PV-Anlagen
      </h1>

      <div class="presentation-cover__accent" aria-hidden="true"></div>

      <p class="presentation-cover__subtitle">
        Steueroptimierte Eigenkapital-Investitionen für Selbständige und Unternehmer — §7g EStG.
      </p>
    </PresentationCover>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationCover from '@/views/MasterPresentation/PresentationCover';

export default {
  name: 'MasterPresentationPrintPage28',

  components: { PrintPageLandscape, PresentationCover },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
};
</script>
